import { ComponentBase } from '../../../../component-base';
import { Injectable } from '@angular/core';
import { IMouseDown, IMouseMove, IMouseRelease } from '../../Interfaces';
import { DrawingsHolderService } from '../../drawings-holder.service';
import { PositionCalculatorService } from '../../position-calculator.service';

@Injectable()
export class MoveShapeComponent extends ComponentBase
  implements IMouseDown, IMouseMove, IMouseRelease {
  private selectedObject;
  private offset;

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService
  ) {
    super();
    this.disable();
    this.drawings.onSelect.subscribe(object => {
      if (object.length < 2) {
        this.selectedObject = object[0];
      } else {
        this.selectedObject = null;
      }
    });
  }

  mouseDown(e: MouseEvent): boolean {
    let result = false;
    if (this.selectedObject) {
      result = true;
      this.offset = this.positionCalculator.calculate(e).sub(this.selectedObject.position);
    }
    return result;
  }

  mouseMove(e: MouseEvent): boolean {
    let result = false;
    if (this.selectedObject && this.offset) {
      result = true;
      const position = this.positionCalculator.calculate(e).sub(this.offset);
      this.selectedObject.position.copy(position);
    }
    return result;
  }

  mouseUp(e: MouseEvent): boolean {
    if (this.offset) {
      this.offset = null;
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/MoveObjectComponent/MoveShapeComponent.ts